import { useQuery } from "@apollo/client";
import { GET_ITEMS_WITH_FILTERS } from "../../../queries/queries";
import ItemCard from "../../common/item-card/item-card";
import React from "react";

import "./home-products.component.css";
import { useHistory } from "react-router";
import useLocationFromSession from "../../../shared/hooks/useLocationFromSession";

const HomeProductsDesk = ({ collectionId, cName }) => {
  const history = useHistory();
  const showItem = (x) => {
    history.push(`/item/${x}`);
  };

  const { queryLocation, isLocationValid } = useLocationFromSession();
  const { loading, data } = useQuery(GET_ITEMS_WITH_FILTERS, {
    // skip: !isLocationValid,
    variables: {
      collectionId,
      groupByProduct: true,
      take: 10,
      skip: 0,
      location: isLocationValid ? queryLocation : null,
    },
  });

  if (loading) return null;

  const productsArr = data?.search.items.slice(0, 4);

  return (
    <HomeProductsDesktop
      cName={cName}
      productsArr={productsArr}
      showItem={showItem}
    />
  );
};

const HomeProductsDesktop = ({ cName, productsArr, showItem }) => (
  <div className={`${cName}`}>
    {productsArr?.map((item, i) => {
      const price =
        item?.priceWithTax.min || (item?.priceWithTax?.value / 100).toFixed(2);
      return (
        <ItemCard
          styles={{
            itemCard: {
              margin: "0px 16px 0px 0px",
            },
          }}
          itemCard={item}
          id={item?.productVariantId}
          productVariantName={item?.productVariantName}
          key={i}
          title={item?.merchantName}
          img={item?.productAsset?.preview}
          description={item?.productName}
          weight={item?.productVariantPriceMeasurement}
          price={price}
          currencyCode={item?.currencyCode}
          merchantLogo={item?.merchantAsset?.preview}
          showItem={() => {
            showItem(item?.slug);
          }}
        />
      );
    })}
  </div>
);

export default HomeProductsDesk;
